import ReservationTypes from "./ReservationTypes";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import StepReturnCustomer from "./StepReturnCustomer";
import SingleDayType from "./SingleDayType";
import MultiLocation from "./MultiLocation";

const steps = [
    {
        id: 1,
        component: MultiLocation,
        name:'Multi Location',
        validator: 'step_return',
        hidden:true,
        error: null,
        multi_location_page: true
    },
    {
        id: 2,
        component: ReservationTypes,
        name:'General information',
        validator: 'step_1',
        error: null,
        success: false,
        hidden: true,
        kiosk_step: true,
    },
    {
        id: 3,
        component: SingleDayType,
        name:'Single Day Type',
        validator: 'step_return',
        error: null,
        success: false,
        hidden:true,
        single_day_type: true

    },
    {
        id: 4,
        _id:1,
        component: Step1,
        name:'General information',
        validator: 'step_1',
        error: null,
        success: false

    },
    {
        id: 5,
        _id:2,
        component: Step2,
        name:'Renters details',
        validator: 'step_2',
        error: null,
        success: false
    },
    {
        id: 6,
        _id:3,
        component: Step3,
        name:'Overview and payment',
        error: null,
        success: false
    },
];

export default steps;
